// build: 20260520161953
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { TenantProvider } from './context/TenantContext';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <TenantProvider>
      <App />
    </TenantProvider>
  </BrowserRouter>
);
